// Boiler Plate Imports
import React, { useEffect, useMemo, useState } from "react";
import colors from "../../theme/colors";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import API from "../../api";

// Conatiner Component Imports
import { Button, Card } from "@mui/material";
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import TableHeader from "../../components/Page/tableHeader";

// Page Component Imports
import MetricBoxes from "../../components/Page/metricBoxes";
import {
  TableComponent,
  ItemLink,
  StatusTag,
} from "../../components/Table/dataGridPro";
import TableSubHeader from "../../components/Page/tableSubHeader";
import { useNavigate } from "react-router-dom";

const PaddingWrapper = styled.div`
  padding: 0 15px 10px;
  @media (max-width: 1080px) {
    padding: 0 0px 10px;
  }
`;

const Table = React.memo(TableComponent);

const AdminNetworksContainer = () => {
  const navigate = useNavigate();

  const [reloadData, setReloadData] = useState(false);
  const [metrics, setMetrics] = useState([]);

  const dispatch = useDispatch();

  const tableColumns = useMemo(() => {
    return [
      {
        headerName: "Network Name",
        field: "name",
        type: "string",
        valueGetter: (value, row) => {
          return row.name;
        },
        renderCell: ({ row }) => {
          return <ItemLink to={`${row.id}`}>{row.name}</ItemLink>;
        },
      },
      {
        headerName: "Organizations",
        field: "organizationIds",
        type: "number",
        valueGetter: (value, row) => {
          return value?.length;
        },
      },
      {
        headerName: "Users",
        field: "userCount",
        type: "number",
      },
      {
        headerName: "Active",
        field: "deleted",
        type: "boolean",
        valueGetter: (value, row) => {
          return !value;
        },
      },
      {
        headerName: "Date Created",
        field: "created",
        type: "dateTime",
        valueGetter: (value, row) => {
          return new Date(value);
        },
      },
    ];
  }, []);

  useEffect(() => {
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Networks",
          link: "/admin/networks",
        },
      ])
    );
    setMetrics([
      {
        title: "TOTAL NETWORKS",
        value: "--",
      },
    ]);
  }, []);

  const dataLayer = {
    GetAllNetworks: async () => {
      const { networks = [], metrics = {} } = await API.Network.NetworkGetAll();

      setMetrics([
        {
          title: "TOTAL NETWORKS",
          value: networks?.length,
        },
      ]);

      networks.sort((a, b) => {
        return b.name - a.name;
      });

      return networks;
    },
  };

  const handlers = {
    createNetworkClick: () => {
      navigate("create");
    },
  };

  return (
    <>
      
      <MetricBoxes title={""} metrics={metrics} />
      <PaddingWrapper>
        <Card>
          <TableHeader>
            <div>
              <h2>Networks</h2>
              <TableSubHeader>
                View all Networks in the Boreas system below
              </TableSubHeader>
            </div>

            <Button
              onClick={handlers.createNetworkClick}
              variant="contained"
              color="primary"
              size="large"
            >
              CREATE NETWORK
            </Button>
          </TableHeader>
          <Table
            columns={tableColumns}
            label={""}
            isAdminView={true}
            reloadData={reloadData}
            placeholder="There are no Networks yet"
            getRowsFunction={dataLayer.GetAllNetworks}
            initialState={{
              pinnedColumns: { left: ["name"] },
              sorting: {
                sortModel: [{ field: "name", sort: "asc" }],
              },
            }}
          />
        </Card>
      </PaddingWrapper>
    </>
  );
};

export default AdminNetworksContainer;
